import { render } from "./PantryRecommendTitle.vue?vue&type=template&id=0cd5d85a&scoped=true&ts=true"
import script from "./PantryRecommendTitle.vue?vue&type=script&lang=ts"
export * from "./PantryRecommendTitle.vue?vue&type=script&lang=ts"

import "./PantryRecommendTitle.vue?vue&type=style&index=0&id=0cd5d85a&lang=scss&scoped=true"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cd5d85a"]])

export default __exports__